import React, { useEffect, useState } from 'react';

//helpers
import { useWindowDimensions } from 'src/components/common/useWindowDimentions';
import { checkValue } from 'src/components/common/helper';
import { useFetchSvgData } from 'src/components/common/modules/hooks/useFetchSvgData';
import { getDeviceImage } from 'src/components/common/theme/component';

//types
import { HeroOverlayImageProps } from '../../typings';

const HeroOverlayImage: React.FC<HeroOverlayImageProps> = (props) => {
  const { heroOverlayImageDesktop, heroOverlayImageMobile } = props;

  const { width: windowWidth } = useWindowDimensions();

  const [device, setDevice] = useState('desktop');

  useEffect(() => {
    setDevice(windowWidth > 1024 ? 'desktop' : windowWidth > 768 ? 'tablet' : 'mobile');
  }, [windowWidth]);

  const overlayDeviceImage =
    device === 'mobile'
      ? checkValue(heroOverlayImageMobile, true)
        ? heroOverlayImageMobile
        : heroOverlayImageDesktop
      : heroOverlayImageDesktop;

  const overlayDeviceImageUrl = getDeviceImage(overlayDeviceImage, 'desktop');

  return (
    <div className="hero-overlay-image-component">
      {overlayDeviceImageUrl ? <img className='hero-overlay-img' src={overlayDeviceImageUrl}></img> : ''}
    </div>
  );
};

export default HeroOverlayImage;
